import {useState,useEffect,useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import { Toast } from 'primereact/toast';

import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import {Titlebar,Searchbox,Label} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate,useLocation   } from "react-router";
import { useSelector } from 'react-redux';
import { Formik, Field, Form } from 'formik';
const Suppliershow = () =>{

    const location = useLocation(); 
    const [productdetail,setProductdetail] = useState({});
    const unitreducer = useSelector((state)=>state.unitreducer); 
    const [users,setUsers] = useState([]);
    const [units,setUnits] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const toast = useRef(null);

    const [rows, setRows] = useState([{ id: Date.now(), quantity: 0 }]);

    const handleAddRow = () => {
        setRows([...rows, { id: Date.now(), quantity: 0 }]);
    };

    const handleRemoveRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
    };  
       useEffect(()=>{
            // getcomponents();
            // getunits();
            console.log("location got the detail");    
            console.log(location);
            // setProductdetail(location.state);
        },[]); 

        const [formData, setFormData] = useState({
            product_name: '',
            sku_code: '',
            stock_on_hand: '',
            stock_needed: '',
            discrepancy_alert: '', // boolean: can be true/false or 'true'/'false'
            restock_alert_threshold: '',
            stock_location: '',
            stock_type: '', // 'finished' or 'component'
        });
        

        const handleChange = (e) => {
            setFormData({
            ...formData,
            [e.target.name]: e.target.value,
            });
        };

        const handleSave = (values) => {
            productservices.createproduct(values).then((response)=>{
                console.log(response);
                 if(response.status == 200){
                    //  console.log€0
                    toast.current.show({ severity: 'success', summary: 'Product', detail: 'Product added successfully' }); 
                 }else{
                    toast.current.show({ severity: 'error', summary: 'Product', detail: `${response.data.data}` }); 
                 }   
            }).catch((error)=>{
                toast.current.show({ severity: 'error', summary: 'Product', detail: 'Error' }); 
            });
        };

        const handleClose = () => {
            // Reset form or close modal logic
            console.log('Form Closed');
        };
    


  const getcomponents  = ()=> {
        setUserloaded(false);
        productservices.getcomponents().then((response)=>{
            if(response.status == 200){
            //   console.log(response.data.data);
              setResults(response.data.data);
              setUserloaded(true);
            }else{
              setUsers([]);
              setUserloaded(true);
            }  
        }).catch((error)=>{
            setResults([]);
            setUserloaded(true);
        }); 
  } 


  const getunits = () =>{
    let temparr = [];
    unitreducer.then((response)=>{
         setUnits(response);
    }).catch((error)=>{
    });
  }

  const displayunits = () =>{
    let temparr = [];
    units.forEach((value,index)=>{
        temparr.push(<option value={value.short_code}>{value.name}</option>)     
    });
    return temparr; 
  }

  const displayData = () =>{
    let temparr = [];
    results.forEach((value,index)=>{
       temparr.push(<option value={value.id}><span>Component : {value.component}</span> Sku : {value.componentSkuCode}</option>)   
    })    
    return temparr;
  }
  
  return(
       <>
          <Toast ref={toast} /> 
          <Bredcrum title={'Product/addproduct'} divider={false}/>
           <div class="row">
              {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}
              <Titlebar text={'Product Detail'}/>
              <div className="col-md-12 mt-3">
                  <div className='card ps-5 pe-5'>
                    <div className='card-body card-body-style'>
                         <div className='row'>
                            <div className="container mt-4">
                                  <div className='flex-box'>    
                                     <div className='' style={{width:'50%'}}>
                                         <img style={{width:'100%'}} src="https://assets-global.website-files.com/5ee0a01b09389eebf4c09b45/65de47590b4b69232050b3ee__id%3D37.webp"/>
                                     </div>

                                     <div className=''>
                                     <table class="table table-bordered table-striped">
                                            <tbody>
                                            <tr>
                                                <th>id</th>
                                                <td>14</td>
                                            </tr>
                                            <tr>
                                                <th>Product Name</th>
                                                
                                                <td>{}</td>
                                            </tr>
                                            {/* <tr>
                                                <th>Sku Code</th>
                                                <td>{productdetail.sku_code}</td>
                                            </tr>
                                            <tr>
                                                <th>Stock type</th>
                                                <td>{productdetail.stock_type}</td>
                                            </tr>
                                            <tr>
                                                <th>Qr Code</th>
                                                <td>{productdetail.stock_type}</td>
                                            </tr> */}
                                            <tr>
                                                <th>stock_on_hand</th>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <th>stock_needed</th>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <th>stock_location</th>
                                                <td>null</td>
                                            </tr>
                                            <tr>
                                                <th>restock_alert_threshold</th>
                                                <td>null</td>
                                            </tr>
                                            <tr>
                                                <th>discrepancy_alert</th>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <th>created_at</th>
                                                <td>2025-06-06T10:30:39.000000Z</td>
                                            </tr>
                                            <tr>
                                                <th>updated_at</th>
                                                <td>2025-06-06T10:30:39.000000Z</td>
                                            </tr>
                                            </tbody>
                                        </table>  
                                     </div>       
                                  </div>      
                            </div>
                         </div>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Suppliershow;